import axiosInstance from "services/AxiosInstance";

export const deleteImportService = async (id: string) => {
  const response = await axiosInstance.delete(`/imports/${id}`);
  return response.data;
};
